export default ".././fonts/result-500.svg";